import "core-js/modules/es.string.link.js";
import { defineComponent as _defineComponent } from 'vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchCard',
  props: {
    link: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    },
    image: {
      type: [Array, Object, String],
      default: ''
    }
  },
  emits: ['close'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var router = useRouter();
    var openProduct = function openProduct() {
      var newTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (newTab) {
        window.open(props.link, '_blank');
      } else {
        router.push(props.link);
        emit('close');
      }
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      router: router,
      openProduct: openProduct,
      AzImg: AzImg,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});